/**
 * @module app/components/BetslipListener
 */
import BetSlipAdapter from './BetSlipAdapter';
import MessageBusTopics from '../../common/MessageBusTopics';
import SelectionViewAdapter from '../views/SelectionViewAdapter';

/**
 * Public API.
 *
 * @type {Object}
 *
 * @public
 */
var api = {

    /**
     * Initializes module and subscribes to some betslip topics
     *
     * @returns {void}
     *
     * @public
     */
    init: function init() {

        window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_CLEAR_ALL, SelectionViewAdapter.clearSelections);
        window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_BET_PLACED, BetSlipAdapter.displayCounts);
        window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_CASH_IN_STARTED, BetSlipAdapter.displayCounts);
        window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_CASHED_IN, BetSlipAdapter.displayCounts);
        window.WH.messageBus.subscribe(
            MessageBusTopics.BETSLIP_REUSE_SELECTIONS_SUCCESS,
            BetSlipAdapter.displayCounts
        );

        //reset the counter in case of failures
        window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_REMOVE_LEG_FAILURE, BetSlipAdapter.displayCounts);
        window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_ADD_LEG_FAILURE, BetSlipAdapter.displayCounts);
        window.WH.messageBus.subscribe(
            MessageBusTopics.BETSLIP_EVENTS_BET_PLACE_FAILED,
            BetSlipAdapter.displayCounts
        );
        //when removing from betslip sporsbooks will decrement the counter immediately
        window.WH.messageBus.subscribe(
            MessageBusTopics.BETSLIP_REMOVE_LEG_STARTED,
            BetSlipAdapter.animatedSelectionCountDecrement
        );
        //when adding or removing via betslip adapter we increment/decrement the counters
        window.WH.messageBus.subscribe(
            MessageBusTopics.BETSLIP_ADAPTER_LEG_ADD,
            BetSlipAdapter.animatedSelectionCountIncrement
        );
        window.WH.messageBus.subscribe(
            MessageBusTopics.BETSLIP_ADAPTER_LEG_REMOVE,
            BetSlipAdapter.animatedSelectionCountDecrement
        );
    },
};

export default api;
